import { z } from 'zod';
// Imported from the module directly rather than the utils barrel, so schemas
// and utils/index.ts cannot form an import cycle.
import type { DimAxis } from '../utils/panel-dims';

/**
 * The axis a dimension may track.
 *
 * One enum for every linkable dimension — framing panels and foam alike. This
 * was previously two enums: PanelDimAxisEnum ('depth' | 'height') and
 * FoamDimAxisEnum. Panels were deliberately narrower because a panel's run
 * length derived from lf_quantity, which made a width link meaningless. Rails
 * now own their length explicitly, so that distinction is gone.
 */
export const DimAxisEnum = z.enum(['width', 'depth', 'height']);
export const DimLinkSchema = DimAxisEnum.nullable().default(null);
export type DimLink = z.infer<typeof DimLinkSchema>;

// Compile-time guard: the Zod enum and the resolver's union must stay identical.
// If either side gains an axis without the other, this stops compiling.
type _AxisParity =
  z.infer<typeof DimAxisEnum> extends DimAxis
    ? DimAxis extends z.infer<typeof DimAxisEnum> ? true : never
    : never;
const _axisParity: _AxisParity = true;
void _axisParity;
